import { render, staticRenderFns } from "./MediaItemDelete.vue?vue&type=template&id=8be87db2"
import script from "./MediaItemDelete.vue?vue&type=script&lang=ts"
export * from "./MediaItemDelete.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports